import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useGet from "../../hooks/useGet";
import { hasData } from "../../utils/handler.utils";
import { spinClaimLeaderboardTableColumns } from "../../utils/reactTableColumns";
import ListPerPage from "../ReactTables/ListPerPage";
import Pagination from "../ReactTables/Pagination";
import ReactTable from "../ReactTables/ReactTable";
import UiHandler from "../UiHandler";

function SpinClaimLeaderboard() {
  const [currentPage, setCurrentPage] = useState(1);
  const [listPerPage, setListPerPage] = useState(10);
  const [urlToFetch, setUrlToFetch] = useState(
    `admin/spin-statistics/users?page=${currentPage}&limit=${listPerPage}`
  );
  const [leaderboardData, loading, error] = useGet(urlToFetch);

  useEffect(() => {
    setUrlToFetch(
      `admin/spin-statistics/users?page=${currentPage}&limit=${listPerPage}`
    );
  }, [currentPage, listPerPage]);

  const users = leaderboardData?.data || [];

  const actionButton = {
    id: "action",
    Header: "Action",
    accessor: "user_id",
    Cell: (e) => {
      return (
        <Link
          className="cstm_btn_small"
          to={`/spin/statistics/user/${e.value}/history`}
        >
          View History
        </Link>
      );
    },
  };

  const withActionButton = [...spinClaimLeaderboardTableColumns, actionButton];

  return (
    <section className="relative container_admin">
      <div className="bg-white overflow-hidden rounded">
        <div className="px-6 py-3 border-b border-gray-200 flex items-center justify-between flex-wrap gap-3">
          <h3 className="text-lg font-bold text-black">
            Spin Claim Leaderboard
            <span className="text-base ml-2 text-blue-600 font-semibold">
              Total user {leaderboardData?.total_user || 0}
            </span>
          </h3>

          <Link
            className="cstm_btn_small !bg-slate-600 hover:!bg-slate-700"
            to="/spin"
          >
            Back to spin
          </Link>
        </div>

        <div>
          <div className="relative min-h-[100px]">
            <UiHandler data={users} loading={loading} error={error} />
            {hasData(users, loading, error) && (
              <ReactTable
                tableId="spin_claim_leaderboard_table"
                columns={withActionButton}
                data={users}
              />
            )}
          </div>

          {Array.isArray(users) && (
            <div className="flex flex-wrap md:flex-nowrap items-center justify-center md:justify-between px-6 py-4 border-t border-gray-200 gap-4">
              <Pagination
                setCurrentPage={setCurrentPage}
                page={currentPage}
                totalList={leaderboardData?.total_user}
                listPerPage={listPerPage}
              />
              <ListPerPage
                listPerPage={listPerPage}
                setListPerPage={setListPerPage}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default SpinClaimLeaderboard;
